function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiggandebakgrund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1933.3219,
    height: 1085.7697,
    viewBox: "0 0 1933.3219 1085.7697",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "swatch7"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#efc9c9",
      stopOpacity: 0.79999982
    },
    offset: 0
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(423.77607,-424.72477)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,5.2863739,-5.2863739,0,1514.5609,424.72477)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      mixBlendMode: "normal",
      fill: "#eacbc8",
      fillOpacity: 0.8,
      strokeWidth: 0.795524
    },
    d: "m 161.69679,328.62832 c -7.40879,-1.60712 -15.59983,-10.14014 -28.46875,-29.65728 -4.81577,-7.30366 -10.61035,-15.5038 -12.87684,-18.22254 -5.70767,-6.84653 -17.38659,-16.56568 -34.881135,-29.02793 -35.018311,-24.94528 -47.968194,-43.89824 -55.281831,-80.90839 -1.002328,-5.0722 -3.363833,-16.62056 -5.247791,-25.66301 -1.883967,-9.04245 -3.260963,-16.61434 -3.060006,-16.82642 0.921845,-0.97287 15.492313,4.43599 21.662696,8.04163 10.23445,5.98047 29.143465,25.20625 35.358294,35.95063 8.480392,14.66116 15.530537,34.2505 21.525923,59.8114 4.02648,17.16657 6.55617,23.84912 11.64492,30.76168 4.9008,6.65729 7.51693,8.3608 5.76554,3.75432 -0.54545,-1.43463 -1.74331,-8.23636 -2.66191,-15.11495 -0.9186,-6.87858 -1.86698,-13.93846 -2.10751,-15.68861 -1.47187,-10.70977 -4.75717,-44.31748 -5.33991,-54.62594 -1.13904,-20.14901 3.53215,-49.57671 10.65016,-67.09424 5.53771,-13.62838 18.93468,-30.132825 51.68066,-63.668171 l 9.09328,-9.312488 1.15533,5.387079 c 3.06204,14.277807 -0.15285,67.32709 -5.04474,83.24396 -1.58399,5.15385 -8.32168,19.89948 -12.34522,27.01783 -2.05116,3.62888 -3.72938,6.82601 -3.72938,7.10476 0,1.25493 -15.33434,22.81747 -20.8847,29.36723 -9.24044,10.90425 -12.88781,16.305 -14.31301,21.19357 -1.7959,6.16015 -1.48107,21.55361 0.69616,34.03763 4.66317,26.73824 15.07127,47.38873 35.56225,70.55833 3.20861,3.62805 6.18783,7.22306 6.62047,7.98892 1.0415,1.84364 -1.04705,2.486 -5.17295,1.591 z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.37,
      fill: "#bdafa8",
      fillOpacity: 0.8
    },
    width: 205.39026,
    height: 365.71796,
    x: -5.7478996e-7,
    y: 0.94868529
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiggandebakgrund);
export default __webpack_public_path__ + "static/media/liggandebakgrund.28b6943a1243206eeb98cdd2492bb18f.svg";
export { ForwardRef as ReactComponent };